import React from "react";
import TopItems from "./profileTopItems";
import ProfileForms from "./profileForms";
import Aux from "../../../hoc/Auxilliary";

const ProfilePage = (props) => {
  return (
    <Aux>
      <TopItems {...props} />
      <ProfileForms fields={props.fields} title={props.title} />
    </Aux>
  );
};

export default ProfilePage;
